<template>
	<div>
		<!-- Headline -->
		<div class="flex xs-between wrap fw7 fs3 p3 pb0" v-if="label">
			<span>{{ label }}</span>
			<span>
				<slot name="label"></slot>
			</span>
		</div>

		<!-- Body -->
		<div class="p2">
			<j-list :list="list" class="b1 r2 bc7">
				<div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
					<slot name="list-item" :item="item">
						<div class="flex xs-5 xs-left xs-middle fw7 c6 lh125">
							{{ item.label }}
						</div>
						<div
							class="flex xs-5 xs-left xs-middle lh125"
							style="overflow-x: auto; overflow-y: hidden;"
						>
							<!-- Display object using custom components -->
							<div
								v-if="
									item.value ? typeof parse(item.value) === 'object' : false
								"
							>
								<!-- Array -->
								<endorsements-data-item-array
									v-if="Array.isArray(parse(item.value))"
									:array="
										item.category === 'address'
											? parseAddressArray(item.value)
											: parse(item.value)
									"
								/>
								<!-- Other object -->
								<endorsements-data-item-object
									v-else
									:object="parse(item.value)"
								/>
							</div>

							<!-- Display other types of value -->
							<div class="lh125" v-else>
								<!-- Link values -->
								<router-link v-if="item.linkTo" :to="item.linkTo">{{
									item.value
								}}</router-link>
								<!-- Normal values -->
								<div v-else>
									{{ item.value }}
								</div>
							</div>
						</div>
						<div class="flex xs-2 xs-right xs-middle lh125">
							<div v-for="(action, i) in item.actions" :key="'action' + i">
								<j-button
									type="tertiary"
									size="medium"
									class="ml2"
									@click="$emit(`item:${action}`, item)"
								>
									<crm-icon
										v-if="action === 'remove'"
										name="delete"
										size="small"
										color="cError"
									/>
									<crm-icon v-else name="edit" size="small" color="c2" />
								</j-button>
							</div>
						</div>
					</slot>
				</div>

				<!-- Empty -->
				<div class="p4 fs3 c1 ta2" v-if="!list.length">
					{{ $t("errors.no_data") }}
				</div>
			</j-list>

			<!-- Slot -->
			<slot></slot>
		</div>
	</div>
</template>

<script>
import JList from "@/components/JList"
import JButton from "@/components/JButton"
import JCard from "@/components/JCard"
import CrmIcon from "@/components/CrmIcon"
import EndorsementsDataItemObject from "./EndorsementsDataItemObject"
import EndorsementsDataItemArray from "./EndorsementsDataItemArray"

export default {
	components: {
		JList,
		JButton,
		JCard,
		EndorsementsDataItemArray,
		EndorsementsDataItemObject,
		CrmIcon
	},
	props: {
		label: {
			type: String,
			default: ""
		},
		list: {
			type: Array,
			default: () => []
		}
	},

	methods: {
		parse(value) {
			try {
				return JSON.parse(value)
			} catch {
				return value
			}
		},

		parseAddressArray(array) {
			return array.map(item => {
				return { [item.type]: item.value }
			})
		}
	}
}
</script>
